import React from "react";
import PublicAuthFormWrapper from "./PublicAuthFormWrapper";
import { ForgotPasswordForm } from "./ForgotPasswordForm";

export const PublicForgotAccount = () => {
  return (
    <PublicAuthFormWrapper title='Reset Password' documentTitle='Reset Password'>
      <ForgotPasswordForm isPublic={true} />
    </PublicAuthFormWrapper>
  );
};

export default PublicForgotAccount;
